export interface GradeIncrementLevel {
  numberOfTicks: number;
  gradeIncrement: number;
}

export const gradeIncrementLevels: GradeIncrementLevel[] = [
  {numberOfTicks: 1, gradeIncrement: 1},
  {numberOfTicks: 2, gradeIncrement: 0.5},
  {numberOfTicks: 3, gradeIncrement: 0.333},
  {numberOfTicks: 4, gradeIncrement: 0.25},
  {numberOfTicks: 5, gradeIncrement: 0.2},
  {numberOfTicks: 8, gradeIncrement: 0.125},
  {numberOfTicks: 10, gradeIncrement: 0.1},
  {numberOfTicks: 20, gradeIncrement: 0.05},
];

export function findLevelIndexByIncrement(value: number) {
  let closestIdx = 0;
  let minDiff = Infinity;

  gradeIncrementLevels.forEach((lvl, idx) => {
    const diff = Math.abs(lvl.gradeIncrement - value);
    if (diff < minDiff) {
      minDiff = diff;
      closestIdx = idx;
    }
  });
  return closestIdx;
}
